<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <img class="iconBanner" src="/Resources/images/icon/Pieces-et-accessoires_hover.png"/>
        <h1 class="bannerTitle">{{ $t('intro.title') }}</h1>
      </div>
    </section>

    <!--Intro-->
    <section class="gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <p class="txt-j mt-5" v-html="$t('intro.txt')"></p>
        </v-col>
      </v-row>
    </section>

    <!--Filter-->
    <section id="filter" class="sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('Filter.title') }}</h2>
            <p v-html="$t('Filter.subTxt')"></p>
            <p v-html="$t('Filter.subTxt2')"></p>
            <ul class="ulPad">
              <li v-html="$t('Filter.ul1')"></li>
              <li v-html="$t('Filter.ul2')"></li>
              <li v-html="$t('Filter.ul3')"></li>
              <li v-html="$t('Filter.ul4')"></li>
              <li v-html="$t('Filter.ul5')"></li>
              <li v-html="$t('Filter.ul6')"></li>
              <li v-html="$t('Filter.ul7')"></li>
              <li v-html="$t('Filter.ul8')"></li>
            </ul>
            <p v-html="$t('Filter.bottomTxt')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Softeners-->
    <section id="Softener" class="sectionPad">
      <v-row class="d-flex">
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/Fusion2_v2-White.jpg')">
            <div class="softImg photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('softeners.title') }}</h2>
            <p class="mt-10" v-html="$t('softeners.txt')"></p>
            <p class="mt-5" v-html="$t('softeners.txt2')"></p>
            <router-link class="button mt-5" to="/contact"><p class="buttonText" v-html="$t('softeners.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Photo gallery softeners-->
    <section class="imgSpace">
      <v-row>
        <v-col cols="12" md="4" class="pa-0">
          <div class="galleryImg softImg2" @click="openLightbox('/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau2.jpg')">
            <div class="galleryOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="pa-0">
          <div class="galleryImg softImg3" @click="openLightbox('/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau.jpg')">
            <div class="galleryOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="pa-0">
          <div class="galleryImg softImg4" @click="openLightbox('/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau2a.jpg')">
            <div class="galleryOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--treatmentWater-->
    <section id="treatmentWater" class="sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle txt-c">{{ $t('treatmentWater.title') }}</h2>
            <p class="mt-4" v-html="$t('treatmentWater.txt')"></p>
            <p class="mt-4" v-html="$t('treatmentWater.txt2')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--UV-->
    <section id="uv" class="sectionPad gridpad4">
      <v-row class="d-flex">
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/ULTRAviolet_deux_white.jpg')">
            <div class="uvImg photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('uv.title') }}</h2>
            <p class="mt-5" v-html="$t('uv.txt')"></p>
            <ol class="ulPad">
              <li v-html="$t('uv.ol1')"></li>
              <li v-html="$t('uv.ol2')"></li>
              <li v-html="$t('uv.ol3')"></li>
              <li v-html="$t('uv.ol4')"></li>
            </ol>
            <p class="mt-5" v-html="$t('uv.bottomTxt')"></p>
            <p class="mt-5" v-html="$t('uv.bottomTxt2')"></p>
            <p class="mt-5" v-html="$t('uv.bottomTxt3')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Treatment Sulfur-->
    <section id="treatmentSulfur" class="v-primary-light-1 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('treatmentSulfur.title') }}</h2>
            <ol class="ulPad">
              <li v-html="$t('treatmentSulfur.ol1')"></li>
              <li v-html="$t('treatmentSulfur.ol2')"></li>
              <li v-html="$t('treatmentSulfur.ol3')"></li>
              <li v-html="$t('treatmentSulfur.ol4')"></li>
              <li v-html="$t('treatmentSulfur.ol5')"></li>
              <li v-html="$t('treatmentSulfur.ol6')"></li>
            </ol>
            <p v-html="$t('treatmentSulfur.bottomTxt')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Osmose-->
    <section id="Osmose" class="gridpad2 sectionPad">
      <v-row class="d-flex flex-wrap-reverse justify-center">
        <v-col cols="12" lg="6">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('osmose.title') }}</h2>
            <p class="mt-4" v-html="$t('osmose.txt')"></p>
            <ol class="ulPad">
              <li v-html="$t('osmose.ol1')"></li>
              <li v-html="$t('osmose.ol2')"></li>
              <li v-html="$t('osmose.ol3')"></li>
              <li v-html="$t('osmose.ol4')"></li>
              <li v-html="$t('osmose.ol5')"></li>
              <li v-html="$t('osmose.ol6')"></li>
              <li v-html="$t('osmose.ol7')"></li>
              <li v-html="$t('osmose.ol8')"></li>
            </ol>
            <p class="mt-4" v-html="$t('osmose.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/Vectapure360_Blanc.jpg')">
            <div class="osmoseImg photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Fountain-->
    <section class="sectionPad gridpad3">
      <v-row class="d-flex">
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/machineEau.jpg')">
            <div class="fountainImg photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('fountain.title') }}</h2>
            <h3 class="fountainSlogan mt-2">{{ $t('fountain.slogan') }}</h3>
            <p class="mt-4" v-html="$t('fountain.txt')"></p>
            <router-link class="button mt-4 mb-4" to="/contact"><p class="buttonText" v-html="$t('fountain.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="v-tierce2 mt-6">
        <v-col cols="12" class="txt-j pt-4 gridpad3">
          <div class="padPump">
            <v-col cols="12"><p v-html="$t('fountain.txt2Title')"></p></v-col>
            <v-row>
              <v-col cols="12" md="6"><p v-html="$t('fountain.txt2A')"></p></v-col>
              <v-col cols="12" md="6"><p v-html="$t('fountain.txt2B')"></p></v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">
          <button class="lightboxClose" @click="closeLightbox">&times;</button>
          <img class="lightboxImg" :src="lightboxSrc" alt="Photo traitement eau"/>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .gridpad { padding-bottom: 50px; }
  .gridpad2 { padding: 0px 100px; }
  .gridpad3 { padding: 0px 100px 45px 100px; }
  .gridpad4 { padding: 0px 100px 0px 100px; }
  .padPump { text-align: justify; padding: 15px 50px; }
  .ulPad { padding: 0px 40px; }
  ul li, ol li { padding: 10px 0px; font-size: 18px; color: rgba(var(--menuColor), 0.6); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../../public/Resources/images/Banner/bannerFilterTraitment.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .iconBanner { width: 55px; height: 55px; }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .fountainSlogan { color: rgba(var(--menuColor), 0.7); font-weight: 500; font-size: 20px; }
  /*#endregion*/

  /*#region Photo Cards*/
  .photoCard {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.18);
    cursor: pointer;
    width: 100%;
    max-width: 520px;
    margin: 20px auto;
  }
  .photoImg {
    height: 420px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #ffffff;
    transition: transform 0.4s ease;
    position: relative;
  }
  .photoCard:hover .photoImg { transform: scale(1.03); }
  .photoHoverOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.30); }
  .zoomIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6));
  }
  .photoCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Image backgrounds*/
  .softImg    { background-image: url("../../../public/Resources/images/Products/Fusion2_v2-White.jpg"); }
  .uvImg      { background-image: url("../../../public/Resources/images/Products/ULTRAviolet_deux_white.jpg"); }
  .osmoseImg  { background-image: url("../../../public/Resources/images/Products/Vectapure360_Blanc.jpg"); }
  .fountainImg{ background-image: url("../../../public/Resources/images/Products/machineEau.jpg"); }
  /*#endregion*/

  /*#region Gallery (softeners 3 photos)*/
  .imgSpace { }
  .galleryImg {
    height: 500px;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    cursor: pointer;
    transition: filter 0.3s ease;
  }
  .galleryImg:hover { filter: brightness(0.80); }
  .galleryOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .galleryImg:hover .galleryOverlay { background-color: rgba(0,0,0,0.25); }
  .galleryImg:hover .zoomIcon { opacity: 1; }
  .softImg2 { background-image: url("../../../public/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau2.jpg"); }
  .softImg3 { background-image: url("../../../public/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau.jpg"); }
  .softImg4 { background-image: url("../../../public/Resources/images/Products/FermeDesVoltigeurs_Traitement-eau2a.jpg"); }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightboxContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
  }
  .lightboxImg {
    max-width: 88vw;
    max-height: 88vh;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    object-fit: contain;
    display: block;
  }
  .lightboxClose {
    position: fixed;
    top: 20px;
    right: 28px;
    font-size: 44px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1;
    opacity: 0.85;
    transition: opacity 0.2s;
    z-index: 100001;
  }
  .lightboxClose:hover { opacity: 1; }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .padPump { padding: 15px; }
    .ulPad { padding: 0px 10px; }
    .galleryImg { height: 250px; }
    .photoImg { height: 280px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .sectionPad { padding: 30px 0px; }
    .gridpad { padding: 0px 25px 50px 25px; }
    .gridpad2 { padding: 0px 25px 60px 25px; }
    .gridpad3 { padding: 0px 25px 0px 25px; }
    .gridpad4 { padding: 0px 25px 60px 25px; }
    .padPump { padding: 15px 20px; }
    .galleryImg { height: 350px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .padPump { padding: 15px 30px; }
    .galleryImg { height: 400px; }
  }
</style>

<script>
  import contactUs from '@/components/bannerContactUs.vue';
  import pageTranslations from '../../../public/Resources/i18N/waterFilterAndTreatment.json';

  export default {
    name: 'waterFilterAndTreatment',
    data: () => ({
      parallaxOffset: 0,
      lightboxOpen: false,
      lightboxSrc: '',
      zoomSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="22" y2="22"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>',
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox(src) {
        this.lightboxSrc = src;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      handleKeydown(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape') this.closeLightbox();
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    components: {
      contactUs,
    },
  }
</script>